import React, { FC } from 'react';
import { Address } from '../../../../reduxStore/store/order/class';
import { Trash2, Edit2, MapPin } from 'react-feather';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'reduxStore/store';
import { deleteCustomerAddress } from 'reduxStore/store/address';

export interface ProductCardProps {
    className?: string;
    data: Address;
    index: number;
    handleModal: (data: Address | null) => void;
}

const AddressCard: FC<ProductCardProps> = ({ className = '', data, index, handleModal }) => {
    const dispatch = useDispatch<AppDispatch>();

    // Only render the parts that are actually present, so the address never
    // renders stray commas for missing fields.
    const streetLine = [data?.address1, data?.address2, data?.cityName, data?.stateName].filter(Boolean).join(', ');
    const regionLine = [data?.countryName, data?.zipCode].filter(Boolean).join(' - ');

    return (
        <div
            className={`group relative flex flex-col h-full rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-5 transition-shadow hover:shadow-md hover:border-slate-300 dark:hover:border-slate-600 ${className}`}
        >
            <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2.5 min-w-0">
                    <span className="flex-shrink-0 flex items-center justify-center w-9 h-9 rounded-full bg-icBlue-100/10 text-icBlue-100">
                        <MapPin size={18} />
                    </span>
                    <h3 className="truncate text-sm font-semibold uppercase tracking-wide text-slate-700 dark:text-slate-200">
                        Address {index + 1}
                    </h3>
                </div>

                <div className="flex items-center gap-1 flex-shrink-0">
                    <button
                        type="button"
                        title="Edit address"
                        aria-label={`Edit address ${index + 1}`}
                        className="flex items-center justify-center w-9 h-9 rounded-full text-slate-500 hover:text-icBlue-100 hover:bg-slate-100 dark:hover:bg-slate-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-icBlue-100 transition-colors"
                        onClick={(e) => {
                            e.preventDefault();
                            handleModal(data);
                        }}
                    >
                        <Edit2 size={17} />
                    </button>
                    <button
                        type="button"
                        title="Delete address"
                        aria-label={`Delete address ${index + 1}`}
                        className="flex items-center justify-center w-9 h-9 rounded-full text-slate-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 transition-colors"
                        onClick={(e) => {
                            e.preventDefault();
                            if (data.id) {
                                dispatch(deleteCustomerAddress({ id: data?.id }));
                            }
                        }}
                    >
                        <Trash2 size={17} />
                    </button>
                </div>
            </div>

            <div className="mt-4 pt-4 border-t border-slate-100 dark:border-slate-800">
                <address className="not-italic text-sm leading-6 text-slate-600 dark:text-slate-400">
                    {streetLine && <span className="block">{streetLine}</span>}
                    {regionLine && <span className="block">{regionLine}</span>}
                </address>
            </div>
        </div>
    );
};

export default AddressCard;
